import { Greyscale } from 'glints-aries';
import styled from 'styled-components';

import LegacyTextField from 'src/components/LegacyTextField/TextField';

export const SuggestionDropdownContainer = styled.div`
  position: relative;
`;

export const SuggestionDropdown = styled.ul`
  position: absolute;
  width: 100%;
  background: ${Greyscale.white};
  z-index: 10;
  margin: 0;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.3);
  padding: 0;
  border-radius: 8px;
  margin-top: 6px;
  li {
    list-style-type: none;
  }
`;

export const SuggestionItem = styled.div`
  font-weight: 400;
`;

export const SearchItemWrapper = styled.li`
  display: flex;
  position: relative;
  padding: 8px 8px;
  cursor: pointer;
  align-items: center;
  padding-inline-start: 0;
  border-radius: 8px;

  svg {
    margin-right: 8px;
    margin-left: 8px;
    opacity: 0.5;
  }

  &:hover {
    background: #ebf5fa;
  }

  &.highlight {
    background: #ebf5fa;
  }
`;

export const SuggestionDropdownError = styled.div`
  font-style: italic;
  color: ${Greyscale.grey};
  padding: 2px 8px;
`;

export const TextField = styled(LegacyTextField)<{
  isHomepage?: boolean;
  isLocationError?: boolean;
}>`
  input {
    padding-top: 8px;
    padding-bottom: 8px;
    border-radius: 8px;
    border: unset;
    font-size: 16px;
    text-overflow: ellipsis;
    background-image: ${({ isHomepage, isLocationError }) =>
      isHomepage
        ? 'none'
        : isLocationError
        ? 'linear-gradient(to left, rgb(245 166 35 /25%), #FFF6E8 20%)'
        : 'linear-gradient(to left, #91b6ca40, #EBF5FA 20%)'};

    :hover {
      border: unset;
    }

    :focus {
      border: unset;
      background-image: ${({ isHomepage, isLocationError }) =>
        isHomepage
          ? 'none'
          : isLocationError
          ? 'linear-gradient(to left, rgb(245 166 35 /25%), #FFF6E8 20%)'
          : 'linear-gradient(to left, #c2e0ee, #c2e0ee 20%)'};
    }
  }

  label {
    font-size: 16px;
    color: #798899;
  }
`;

export const NoLocationFoundWrapper = styled.li`
  display: flex;
  position: relative;
  pointer-events: none;
  padding: 8px 8px;
  align-items: center;
  padding-inline-start: 0;
  border-radius: 8px;

  div {
    font-weight: 400;
    padding-left: 16px;
  }
`;

export const SuggestedTitle = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 8px;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 8px;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  display: inline-flex;
  div {
    color: black;
    font-size: 12px;
    font-family: Poppins, sans-serif;
    font-weight: 600;
    word-wrap: break-word;
  }
`;
